import { useContext } from "react";
import { UserContext } from "../contexts/authUser";

const useAdminUser = () => {
  const { user } = useContext(UserContext);
  return user || null;
};

export default useAdminUser;



// WEBPACK FOOTER //
// ./webAdmin/hooks/useAdminUser.js